<template>

  <div class="row justify-content-between">
    <Button :title="this.sort==='sort'?'<i class=\'fas fa-sort-numeric-up-alt\'></i>':'<i class=\'fas fa-sort-numeric-up\'></i>'" class-name="btn-info mb-1" :onclick="()=>this.sort = this.sort==='sort'?'asort':'sort'"/>
    <Button title="Yeni Şifre Ekle" class-name="btn-dark mb-1" :onclick="()=>ekleModal()"/>
  </div>
  <div class="row">

   <TableContainer :titles="['Sıra','Şifre','İsim','İşlemler']">
        <tr v-for="data in showedData" :key="data.firebaseKey">
          <td class="text-white-50">{{data.kacinci}}</td>
          <td class="text-light">
            {{data.kisa}}
            <hr>
            <div v-for="(harf,i) in data.harfler" :key="i">
              <strong>{{harf.harf}} : </strong> {{harf.aciklama}}
            </div>
          </td>
          <td class="text-light">{{data.sifre}}</td>
          <td>
            <Button title="Düzenle" class-name="btn-outline-info" :onclick="()=>duzenleModal(data.firebaseKey)"/>

              <Button title="Sil" class-name="btn-outline-danger ml-1 mt-1"   :onclick="()=>deleteDataConfirm(data.firebaseKey)"/>

          </td>
        </tr>
   </TableContainer>
    <DeleteAlert :show="dataWillDelete.show" :onOkey="()=>deleteData(this.gecerliId)" v-on:show-box-changed="handleShowBoxChanged" :title="dataWillDelete.baslik"/>
    <Pagination :page="page" :item-count="itemCount" v-if="pageShow"/>
  </div>
  <Modal :className="modalShow" title="Şifre Ekle / Düzenle" @on-closed="handleClose">

      <TextInput title="Başlık" name="sifre" placeholder="Başlık Girin" :model="sifre" v-on:datachanged="dataChanged"/>
      <TextInput title="Sırası" name="kacinci" placeholder="Sıralama" type="number" :model="kacinci" v-on:datachanged="dataChanged"/>
      <TextInput title="İçerik" name="kisa" placeholder="İçerik Girin" :model="kisa" v-on:datachanged="dataChanged"/>
      <h6>Harfler <a @click.prevent="yeniHarfEkle" class="badge badge-info pointer">Yeni Ekle</a></h6>
    <div v-for="(harf,i) in harfler" :key="i" class="mt-2">

      <input  name="harf" type="text" placeholder="Harf Girin" v-model="harfler[i].harf" class="d-inline border border-top-0 border-left-0 border-right-0 border-dark mr-1"/> :
      <input name="aciklama" type="text" placeholder="Açıklama Girin" v-model="harfler[i].aciklama" class="form-text d-inline border border-top-0 border-left-0 border-right-0 border-dark mr-1"/>
      <a @click.prevent="harfiSil(i)" class="badge badge-danger pointer"><i class="fa fa-times"></i></a>
    </div>
    <Button title="Kaydet" class-name="btn-success" :onclick="()=>updateData()"/>
  </Modal>

</template>
<script>
import Modal from '@/components/App/Modal'
import Pagination from '@/components/App/Pagination'
import TableContainer from '@/views/containers/TableContainer'
import Button from '@/components/forms/Button'
import TextInput from '@/components/forms/TextInput'
import DeleteAlert from '@/components/App/DeleteAlert'
import {
  findCurrentData,
  findNewKacinci,
  findPage,
  findSortedData,
  get,
  insert,
  remove,
  update
} from '@/crud'
export default {
  name: 'Sifreler',
  components: {
    DeleteAlert,
    TextInput,
    Button,
    TableContainer,
    Pagination,
    Modal
  },
  props: ['search'],
  data () {
    return {
      modalShow: 'hide',
      contents: [],
      itemCount: 0,
      page: 1,
      showedData: [],
      pageShow: true,
      kisa: '',
      sifre: '',
      kacinci: '',
      harfler: [],
      gecerliId: false,
      sort: 'sort',
      dataWillDelete: { show: false, baslik: '' },
      tableName: 'sifreler/' + this.$route.params.id
    }
  },
  methods: {
    yeniHarfEkle () {
      this.harfler.push({ harf: '', aciklama: '' })
    },
    harfiSil (i) {
      this.harfler.splice(i, 1)
    },
    handleShowBoxChanged () {
      this.dataWillDelete = { show: false, baslik: '' }
      this.gecerliId = false
    },
    workContent () {
      this.page = findPage(this.$route)
      this.contents = findSortedData(this.sort, this.contents)
      this.showedData = this.content
    },
    duzenleModal (data) {
      const current = findCurrentData(this.contents, data)
      this.sifre = current.sifre
      this.kisa = current.kisa
      this.kacinci = current.kacinci
      this.harfler = current.harfler
      this.gecerliId = data
      this.modalShow = 'show'
    },
    ekleModal () {
      this.sifre = ''
      this.kisa = ''
      this.harfler = []
      this.kacinci = findNewKacinci(this.contents, 'kacinci')
      this.gecerliId = false
      this.modalShow = 'show'
    },
    deleteData () {
      remove(this.tableName + '/' + this.gecerliId, this.handleShowBoxChanged)
    },
    deleteDataConfirm (data) {
      const current = findCurrentData(this.contents, data)
      this.gecerliId = data
      this.dataWillDelete = { show: true, baslik: current.sifre }
    },
    updateData () {
      if (this.gecerliId) {
        const current = findCurrentData(this.contents, this.gecerliId)
        delete current.firebaseKey
        update(this.tableName + '/' + this.gecerliId, {
          kisa: this.kisa,
          sifre: this.sifre,
          kacinci: this.kacinci,
          harfler: this.harfler
        }, () => {
          this.modalShow = 'hide'
        })
      } else {
        insert(this.tableName, {
          kisa: this.kisa,
          sifre: this.sifre,
          kacinci: this.kacinci,
          harfler: this.harfler
        }, () => {
          this.modalShow = 'hide'
        })
      }
    },
    handleClose (data) {
      this.modalShow = data
    },
    dataChanged (data, name) {
      this[name] = data
    },
    getData () {
      this.$store.dispatch('setLoading', true)
      get({
        child: this.tableName,
        callback: snapshot => {
          this.contents = this.makeArray(snapshot.val())
          this.workContent()
          this.itemCount = snapshot.numChildren()
          const currentDers = findCurrentData(this.$store.getters.dersler, this.$route.params.id)
          this.$emit('baslikchange', currentDers.isim + ' / Şifreler')
          this.$store.dispatch('setLoading', false)
        }
      })
    }
  },
  computed: {
    content () {
      if (this.search && this.search !== '') {
        return this.searchContent(this.contents, this.search, 'sifre')
      } else {
        return this.findContent(this.contents, this.page)
      }
    }
  },
  created () {
    this.getData()
  },
  watch: {
    $route: function (_new, old) {
      if (_new.params.id !== old.params.id) {
        this.tableName = 'sifreler/' + _new.params.id
        this.getData()
      }
      if (_new.params.page !== old.params.page) {
        this.workContent()
      }
    },
    sort: function () {
      this.workContent()
    },
    search: function () {
      if (this.search && this.search !== '') {
        this.pageShow = false
      } else {
        this.pageShow = true
      }
      this.workContent()
    }
  }

}
</script>
<style scoped>
.pointer{
  cursor: pointer;
}
</style>
